import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const DetailsSectionSidePaddedSection = styled.div`
  margin: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;

  ${fromMd} {
    margin: 0;
  }
`

export const ReviewsPlaceholder = styled.div`
  min-height: 50vh;
  min-height: clamp(25svh, 250px, 33svh);
`
